import React from 'react';
import { useIntl } from 'react-intl';
import PreviewImages from 'app/containers/MonitoringPage/components/PreviewImages';
import { Study } from 'app/interfaces/Study';

type PreviewAreaProps = {
  study?: Study;
};

const PreviewArea: React.FC<PreviewAreaProps> = ({ study }) => {
  const intl = useIntl();
  const previewMode = study ? 'preview' : 'preview hidden';

  return (
    <div className={previewMode}>
      <PreviewImages study={study} />
      <div className="preview-report">
        <div>
          <div
            className="editable-report non-editable-report"
            style={{ height: '100%', borderRadius: '3px' }}
          >
            <textarea
              value={study?.comment}
              disabled
              placeholder={intl.formatMessage({ id: 'monitoring.comment' })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewArea;
